import { ISensor } from 'app/shared/model/sensor.model';
import { ISensorHardware } from 'app/shared/model/sensor-hardware.model';
import { IDeviceTruckImplement } from 'app/shared/model/device-truck-implement.model';

export interface IDeviceSensor {
  id?: number;
  hardwareKey?: string | null;
  sensor?: ISensor | null;
  sensorHardware?: ISensorHardware | null;
  deviceTruckImplement?: IDeviceTruckImplement | null;
}

export const defaultValue: Readonly<IDeviceSensor> = {};
